import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
  CREATE_SERVICE_IDENTIFIER_SUCCESS,
  FETCH_SERVICE_IDENTIFIER_SUCCESS,
  GET_SERVICE_IDENTIFIER_FROM_ASSET_SUCCESS,
  GET_SERVICE_IDENTIFIER_SUCCESS,
  SAVE_SERVICE_IDENTIFIER_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchFilter, fetchStart, fetchSuccess } from "./Common";
import { getUser } from "./Auth";
import { arrayToCSV, downloadCSV } from "../../util/methods";
import { message } from "antd";
import Swal from "sweetalert2";


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_SERVICE_IDENTIFIER_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_SERVICE_IDENTIFIER_QUERY,
    query
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_SERVICE_IDENTIFIER_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_SERVICE_IDENTIFIER_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { serviceIdentifier } = store.getState();
      const { query } = serviceIdentifier;
      const response = await axios.get(`/service-identifier?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { serviceIdentifier } = store.getState();
      const { query } = serviceIdentifier;
      const response = await axios.get(`/service-identifier/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns);
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload, redirect = true, module) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/service-identifier`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({ data: response.data }));
      }
      if (!redirect) {
        dispatch(fetchFilter(module));
      } else {
        history.push('/pmschedule');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.put(`/service-identifier/${id}`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }

      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/pmschedule');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/service-identifier/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.delete(`/service-identifier/${id}`);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getServiceIdentifierFromAsset = (assetId) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/preventive-maintenance/si-from-asset/${assetId}`);
      // console.log(response.data);
      dispatch(fetchSuccess());
      dispatch(fetchServiceIdentifierSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchServiceIdentifierSuccess = ({ data }) => {
  return {
    type: GET_SERVICE_IDENTIFIER_FROM_ASSET_SUCCESS,
    data
  };
};

export const uploadPmChecklist = (formData) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`common/upload/checklist`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
      const { data } = response;
      let html = '<div style="font-size: smaller">';
      if (data.filter(doc => doc.error) && data.filter(doc => doc.error).length) {
        data.filter(doc => doc.error).map(err => {
          html += `<p style="color: #7c3535">${err.error}</p>`;
        })
      }
      if (data.filter(doc => doc.success) && data.filter(doc => doc.success).length) {
        data.filter(doc => doc.success).map(sc => {
          html += `<p style="color: #3DA4E6">${sc.success}</p>`;
        })
      }
      html += `</div>`;
      Swal.fire({
        title: 'Service Identifier created!',
        html: `<div>${html}</div>`,
        icon: 'warning'
      })
      dispatch(fetchSuccess());
      history.push("/pmschedule");
      // dispatch(updateProcessSuccess({data: response.data}));
      dispatch(getResource());
    } catch (error) {
      message.error(`Upload error, contact admin`);
      console.log('Error****:', error);
      dispatch(fetchError(error));
    }
  };
};
